import { DeviceTypes } from 'packages/smart-home-support/models';

export const deviceTypes: DeviceTypes = {
  desktop: { label: 'Desktop' },
  dvdPlayer: { label: 'DVD Player' },
  fitness: { label: 'Fitness Tracker' },
  gamingConsole: { label: 'Game System' },
  laptop: { label: 'Laptop' },
  printer: { label: 'Printer' },
  router: { label: 'Router' },
  smartCamera: { label: 'Smart Security Camera' },
  smartSpeaker: { label: 'Smart Speaker' },
  smartThermostat: { label: 'Smart Thermostat' },
  smartWatch: { label: 'Smart Watch' },
  streaming: { label: 'Streaming Device' },
  tablet: { label: 'Tablet' },
  tv: { label: 'TV' },
  wirelessSpeaker: { label: 'Wireless Speaker' },
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/data/index.ts